/**
 * Name and general concept taken from Material UI Color System.
 *
 * @see https://material.io/design/color/the-color-system.html
 */
// Warning: Change colors can affect many components.
const coreColors = {
  primary: '#5D5AFF',
  primaryLight: '#9896FF',
  primaryDark: '#5754f2',

  secondary: '#b8b8b8',
  secondaryLight: '#DCDCDC',
  secondaryDark: '#898989',

  background: '#ffffff',
  backgroundDisabled: '#a0a0a0',
  surface: '#e0e2e3',
  surfaceDisabled: '#a0a2a3',

  greyBackground: '#fafafa',
  greyBackgroundMedium: '#f2f2f2',
  greyBackgroundDark: '#eeeeee',

  charcoal: '#565656',
  black: '#000000',
  greyDark: '#24221f',
  grayDarkish: '#666666',
  gray: '#777777',
  lightGray: '#cdcdcd',
  white: '#ffffff',
  gold: '#F1B505',
  lightGold: '#fdebb4',
  darkGold: '#af8304',

  yellow: '#fee857',
  blue: '#0007FF',
  purple: '#b88bbb',
  filterBackground: 'rgba(237, 237, 237, 0.75)',

  green: {
    lighter: '#DDFFA9',
    light: '#9BCE50',
    normal: '#4caf50',
    dark: '#24942A',
  },

  red: {
    lighter: '#f5d6cf',
    light: '#e8aea0',
    normal: '#b22b00',
  },

  orange: {
    lighter: '#fff4e5',
    normal: '#ff9800',
    darker: '#663c00',
  },
};

export const colors = {
  ...coreColors,

  // Status
  status: {
    error: {
      fill: coreColors.red.normal,
    },
    warning: {
      fill: coreColors.orange.normal,
      textDark: coreColors.orange.darker,
      bgLight: coreColors.orange.lighter,
    },
    success: {
      fill: coreColors.green.normal,
    },
  },

  greyDivider: '#D5D5D5',
  greyDividerLight: '#f1f1f1',

  // Typography
  link: coreColors.primary,
  linkHover: coreColors.secondaryDark,
  text: coreColors.black,

  // Layout
  border: coreColors.black,
  panelBackground: coreColors.surface,
  panelBackgroundDisabled: coreColors.surfaceDisabled,

  // Specific
  subquestionContainer: '#f4f4f4',
  sectionProgressBarUnreached: '#BFBFBF',
  placeholder: '#e0e0e0',

  logo: '#737a83',
  discountBannerBg: coreColors.green.lighter,
  discountBannerText: coreColors.green.dark,
  exclusivePriceBg: '#E9E9FE',
  exclusivePriceText: '#7875FF',

  // External
  amazonBlack: '#131921',
  facebookBlue: '#3c5999',
  smsGreen: '#4bc358',
};

export type ColorTheme = typeof colors;
